import React from 'react';

interface DigitKeypadProps {
  selectedDigit: number;
  onDigitSelect: (digit: number) => void;
}

const DigitKeypad: React.FC<DigitKeypadProps> = ({
  selectedDigit,
  onDigitSelect
}) => {
  return (
    <div className="digit-keypad">
      {[0,1,2,3,4,5,6,7,8,9].map(digit => (
        <button 
          key={digit}
          className={`digit-btn ${selectedDigit === digit ? 'active' : ''}`}
          onClick={() => onDigitSelect(digit)}
        >
          {digit}
        </button>
      ))}
    </div>
  );
};

export default DigitKeypad;
export { DigitKeypad };
